<!--
 * @Description: 文件预览，除了zip，添加了fileList [{url,type}]。之前要求文件预览也在左侧展示，这次不需要了，文件直接打开新窗口展示
 * @Date: 2021-10-30 15:12:11
-->
<template>
  <transition name="viewer-fade">
    <div
      ref="el-image-viewer__wrapper"
      :style="{ 'z-index': zIndex, ...$parent.wrapperStyle }"
      class="el-image-viewer__wrapper"
      tabindex="-1"
    >
      <div class="el-image-viewer__mask"></div>
      <!-- CLOSE -->
      <span
        v-if="config.closable"
        class="el-image-viewer__btn el-image-viewer__close"
        @click="hide"
      >
        <!-- <i class="el-icon-circle-close"></i> -->
      </span>
      <!-- ARROW -->
      <template v-if="!isSingle">
        <span
          :class="{ 'is-disabled': !infinite && isFirst }"
          class="el-image-viewer__btn el-image-viewer__prev"
          @click="prev"
        >
          <i class="el-icon-arrow-left" />
        </span>
        <span
          :class="{ 'is-disabled': !infinite && isLast }"
          class="el-image-viewer__btn el-image-viewer__next"
          @click="next"
        >
          <i class="el-icon-arrow-right" />
        </span>
      </template>
      <!-- ACTIONS -->
      <div
        class="el-image-viewer__btn el-image-viewer__actions"
        v-if="currentImg.type === 'image'"
      >
        <div class="el-image-viewer__actions__inner">
          <i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
          <i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <!-- <i :class="mode.icon" @click="toggleMode"></i> -->
          <i class="el-image-viewer__actions__divider"></i>
          <i
            class="el-icon-refresh-left"
            @click="handleActions('anticlocelise')"
          ></i>
          <i
            class="el-icon-refresh-right"
            @click="handleActions('clocelise')"
          ></i>
        </div>
      </div>
      <!-- CANVAS -->
      <div
        class="el-image-viewer__canvas"
        style="overflow:hidden"
        v-if="fileList.length"
      >
        <template v-for="(file, i) in fileList">
          <img
            v-if="i === index && file.type === 'image'"
            :key="file.url"
            ref="img"
            :src="currentImg.url"
            :style="imgStyle"
            class="el-image-viewer__img"
            @error="handleImgError"
            @load="handleImgLoad"
            @mousedown="handleMouseDown"
          />
          <!-- 暂不需要 -->
          <!-- <iframe
            v-if="i === index && file.type !== 'image'"
            :key="file.url"
            :src="'//view.xdocin.com/xdoc?_xdoc=' + currentImg.url"
          /> -->
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import { off, on } from 'element-ui/src/utils/dom';
import { isFirefox, rafThrottle } from 'element-ui/src/utils/util';

const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};

const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';

export default {
  name: 'FileViewer',
  props: {
    // 数组中元素：{type,url} 文件类型 image || * 支持图片与文件预览, 文件地址
    fileList: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    initialIndex: {
      type: String,
      default: '0_now' // 下表+时间戳，防止通过键盘切换后传入的initialIndex没有更变
    }
  },

  data() {
    return {
      index: +this.initialIndex.split('_')[0],
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    };
  },
  computed: {
    isSingle() {
      return this.fileList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.fileList.length - 1;
    },
    currentImg() {
      return this.fileList[this.index] || { url: '' };
    },
    imgStyle() {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    },
    config() {
      return Object.assign(
        {},
        {
          mousewheel: true,
          closable: true
        },
        this.$parent['conf']
      );
    }
  },
  watch: {
    initialIndex(val) {
      const index = val.split('_')[0];
      this.index = +index || 0;
    },
    index: {
      handler: function(val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg(val) {
      this.$nextTick(_ => {
        const $img = this.$refs.img[0];
        if (!$img.complete) {
          this.loading = true;
        }
      });
    }
  },
  methods: {
    hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall() {
      this._keyDownHandler = rafThrottle(e => {
        const keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            this.hide();
            break;
          // SPACE
          case 32:
            this.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            this.prev();
            break;
          // UP_ARROW
          case 38:
            this.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            this.next();
            break;
          // DOWN_ARROW
          case 40:
            this.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = rafThrottle(e => {
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          this.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          this.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(
        this.$refs['el-image-viewer__wrapper'],
        'keydown',
        this._keyDownHandler
      );
      if (this.config.mousewheel === true) {
        on(
          this.$refs['el-image-viewer__wrapper'],
          mousewheelEventName,
          this._mouseWheelHandler
        );
      }
    },
    deviceSupportUninstall() {
      off(
        this.$refs['el-image-viewer__wrapper'],
        'keydown',
        this._keyDownHandler
      );
      off(
        this.$refs['el-image-viewer__wrapper'],
        mousewheelEventName,
        this._mouseWheelHandler
      );
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad(e) {
      this.loading = false;
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown(e) {
      const wrapperDom = this.$refs['el-image-viewer__wrapper'];
      const { offsetWidth, offsetHeight } = wrapperDom;
      const wrapperWidth = offsetWidth - 10;
      const wrapperHeight = offsetHeight - 10;
      if (this.loading || e.button !== 0) return;
      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
        if (
          ev.pageX > wrapperWidth ||
          ev.pageX <= 0 ||
          ev.pageY <= 10 ||
          ev.pageY > wrapperHeight
        ) {
          off(
            this.$refs['el-image-viewer__wrapper'],
            'mousemove',
            this._dragHandler
          );
        }
      });
      on(
        this.$refs['el-image-viewer__wrapper'],
        'mousemove',
        this._dragHandler
      );
      on(this.$refs['el-image-viewer__wrapper'], 'mouseup', ev => {
        off(
          this.$refs['el-image-viewer__wrapper'],
          'mousemove',
          this._dragHandler
        );
      });

      e.preventDefault();
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode() {
      if (this.loading) return;

      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index = modeValues.indexOf(this.mode);
      const nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev() {
      if (this.isFirst && !this.infinite) return;
      const len = this.fileList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next() {
      if (this.isLast && !this.infinite) return;
      const len = this.fileList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions(action, options = {}) {
      if (this.loading) return;
      const { zoomRate, rotateDeg, enableTransition } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      };
      const { transform } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat(
              (transform.scale - zoomRate).toFixed(3)
            );
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    }
  },
  mounted() {
    this.deviceSupportInstall();
    // add tabindex then wrapper can be focusable via Javascript
    // focus wrapper so arrow key can't cause inner scroll behavior underneath
    this.$refs['el-image-viewer__wrapper'].focus();
  }
};
</script>
<style scoped>
iframe {
  width: 650px;
  height: 600px;
  z-index: 1;
}
</style>
